<clr-modal
  #modal
  id="cameraModalWrapper"
  [clrModalOpen]="showWebcam()"
  (clrModalOpenChange)="showWebcam.set($event)"
  [clrModalSize]="'xl'"
  [clrModalClosable]="webcamReady()">
  <h3 class="modal-title">{{ 'Kamera' | mrTranslate }}</h3>
  <div #sizeRef class="modal-body">
    @if (resizeReady()) {
      <webcam
        [width]="sizePx().width"
        [height]="sizePx().height"
        [videoOptions]="videoOptions()"
        [trigger]="triggerObservable"
        [allowCameraSwitch]="allowCameraSwitch()"
        [switchCamera]="nextWebcamObservable"
        (cameraSwitched)="$event && webcamReady.set(true); saveDeviceID($event)"
        (imageCapture)="handleImage($event)"
        [imageQuality]="1"
        (initError)="handleInitError($event)" />
    }
    <!-- (videoInitialized)="onVideoInit($event)" -->
  </div>

  <div class="modal-footer">
    @if (isVideoRecording()) {
      <div style="margin-top: 5px; padding-right: 10px">
        {{ recordingTime() | get: recordingTimeFormatted }}
      </div>
    }

    @if (isVideoMode()) {
      <button type="button" class="btn btn-icon" (click)="startRecording()">
        @if (!isVideoRecording()) {
          <cds-icon shape="video-camera" />
        }

        @if (isVideoRecording()) {
          <cds-icon shape="stop" style="color: red" solid="true" />
        }
      </button>
    }

    @if (!isVideoRecording()) {
      @if (allowVideo()) {
        <button type="button" class="btn btn-outline" (click)="isVideoMode.set(!isVideoMode())">
          {{ (isVideoMode() ? 'Foto' : 'Video') | mrTranslate }}
        </button>
      }
      @if (multipleWebcamsAvailable()) {
        <button type="button" class="btn btn-outline" (click)="showNextWebcam(true)">
          {{ 'Kamera wechseln' | mrTranslate }}
        </button>
      }
      <button type="button" class="btn btn-outline" (click)="takePicture()">
        {{ 'Bild' | mrTranslate }}
      </button>
    }

    <!-- <button type="button" [disabled]="!webcamReady" class="btn btn-outline" (click)="modal.close()">{{ 'Beenden' | mrTranslate }}</button> -->
  </div>
</clr-modal>
